import { MagnifyingGlass } from '@phosphor-icons/react';
import { Checkbox } from '@/components/ui-kit/checkbox';
import { Input } from '@/components/ui-kit/input';
import { Label } from '@/components/ui-kit/label';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui-kit/select';
import { USER_ACCOUNT_STATUS_OPTIONS, type UserAccountStatus } from '../../utils/users-roles.utils';

const ALL = 'all';

type UsersRolesToolbarProps = {
  search: string;
  onSearchChange: (value: string) => void;
  status: UserAccountStatus | typeof ALL;
  onStatusChange: (value: UserAccountStatus | typeof ALL) => void;
  role: string;
  onRoleChange: (value: string) => void;
  roleOptions: string[];
  simulateError: boolean;
  onSimulateErrorChange: (value: boolean) => void;
};

export const UsersRolesToolbar = ({
  search,
  onSearchChange,
  status,
  onStatusChange,
  role,
  onRoleChange,
  roleOptions,
  simulateError,
  onSimulateErrorChange,
}: UsersRolesToolbarProps) => {
  return (
    <div className="flex flex-wrap items-center gap-3">
      <div className="relative min-w-[220px] flex-1">
        <MagnifyingGlass
          className="pointer-events-none absolute left-3 top-1/2 size-[18px] -translate-y-1/2 text-muted-foreground"
          aria-hidden
        />
        <Input
          value={search}
          onChange={(event) => onSearchChange(event.target.value)}
          placeholder="Search by name or email"
          className="h-10 rounded-md border-input bg-white pl-10 text-sm"
          aria-label="Search by name or email"
        />
      </div>

      <label className="flex items-center gap-2 text-xs text-muted-foreground">
        Status
        <Select value={status} onValueChange={(value) => onStatusChange(value as UserAccountStatus)}>
          <SelectTrigger className="h-10 w-[9rem] bg-white" aria-label="Filter by status">
            <SelectValue />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value={ALL}>All statuses</SelectItem>
            {USER_ACCOUNT_STATUS_OPTIONS.map((option) => (
              <SelectItem key={option.value} value={option.value}>
                {option.label}
              </SelectItem>
            ))}
          </SelectContent>
        </Select>
      </label>

      <label className="flex items-center gap-2 text-xs text-muted-foreground">
        Role
        <Select value={role} onValueChange={onRoleChange}>
          <SelectTrigger className="h-10 w-[9rem] bg-white" aria-label="Filter by role">
            <SelectValue />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value={ALL}>All roles</SelectItem>
            {roleOptions.map((option) => (
              <SelectItem key={option} value={option}>
                {option}
              </SelectItem>
            ))}
          </SelectContent>
        </Select>
      </label>

      <div className="ml-1 flex items-center gap-2">
        <Checkbox
          id="simulate-server-error"
          checked={simulateError}
          onCheckedChange={(checked) => onSimulateErrorChange(checked === true)}
        />
        <Label
          htmlFor="simulate-server-error"
          className="cursor-pointer text-sm font-normal text-muted-foreground"
        >
          Simulate a server error
        </Label>
      </div>
    </div>
  );
};
